"use client";

import { styled } from "styled-components";

import { poppins_caption_lg_medium } from "@/shared/font/poppins/caption";
import {
  ptSerif_body_md_regular,
  ptSerif_body_sm_regular,
} from "@/shared/font/pt-serif/body";

export const RelativeWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  max-width: 100%;
`;

export const InfoGroup = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.4rem;
  width: 100%;
`;

export const DisplayInfoWrapper = styled.div<{ $singleItemFill?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.2rem;
  width: ${({ $singleItemFill }) => ($singleItemFill ? "100%" : "fit-content")};
  min-width: ${({ $singleItemFill }) => ($singleItemFill ? "0" : undefined)};
  max-width: calc(100% - 4rem);
  flex-wrap: nowrap;
  min-height: 2.1rem;
  overflow: visible;
`;

export const InfoWrapper = styled.div<{
  $fillAvailable?: boolean;
  $shrinkForEllipsis?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  width: ${({ $fillAvailable }) => ($fillAvailable ? "100%" : "fit-content")};
  ${({ $fillAvailable }) =>
    $fillAvailable &&
    `
    flex: 1;
    min-width: 0;
  `}
  ${({ $shrinkForEllipsis }) =>
    $shrinkForEllipsis &&
    `
    flex: 0 1 auto;
    min-width: 0;
  `}
`;

export const Text = styled.div<{
  $textSize: "md" | "sm";
  $shrinkInFlex?: boolean;
}>`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${({ $textSize }) =>
    $textSize === "sm" ? ptSerif_body_sm_regular : ptSerif_body_md_regular}
  ${({ $shrinkInFlex }) =>
    $shrinkInFlex &&
    `
    min-width: 0;
    width: 100%;
  `}
`;

export const BadgeContentWrapper = styled.div`
  position: relative;

  &:hover > .badge-tooltip {
    display: block;
    opacity: 1;
  }
`;

export const CountText = styled.div`
  display: flex;
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  align-items: center;
  gap: var(--Spacing-2, 0.2rem);
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  ${poppins_caption_lg_medium}
`;

export const BadgeTooltipWrapper = styled.div<{
  $show?: boolean;
  $maxWidth?: string;
}>`
  position: absolute;
  top: 100%;
  right: 0;
  display: ${({ $show }) => ($show ? "block" : "none")};
  opacity: ${({ $show }) => ($show ? "1" : "0")};
  width: max-content;
  max-width: ${({ $maxWidth }) => $maxWidth || "40rem"};
  padding: var(--Spacing-4, 0.4rem);
  background: var(--Color-Common-Bg-Primary, #fff);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  z-index: 100;
`;

export const TooltipContentsWrapper = styled.div<{
  $flexDirection: "row" | "column";
}>`
  display: flex;
  flex-direction: ${(props) => props.$flexDirection};
  flex-wrap: wrap;
  gap: 0.4rem;
  height: fit-content;
`;

export const TooltipInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const TooltipText = styled.div`
  ${ptSerif_body_sm_regular}
  color: var(--Color-Common-Text-Primary, #2a2f37);
`;

export const TooltipBulletText = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-left: 1.2rem;
  break-inside: avoid-column;
  overflow-wrap: anywhere;
  ${ptSerif_body_sm_regular}

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  color: var(--Color-Common-Text-Primary, #2a2f37);

  &::before {
    content: "•";
    position: absolute;
    top: 0;
    left: 0;
    width: 1.4rem;
    height: 1.4rem;
    color: #2a2f37;
    font-size: 1.2rem;
  }
`;
